export default __webpack_public_path__ + "static/media/novatek.e058ee78.jpg";